<div
  class="container-filter__padding"
  matMenuContent
  (click)="$event.stopPropagation()"
>
  <div class="item-filter" style="margin: 4px;">
    <div class="flex items-center" style="padding: 6px 3px 6px 3px; border: 1px solid #e0e0e0; border-radius: 4px;">
      <app-date-range-picker [form]="dateRangeForm"></app-date-range-picker>
    </div>
  </div>

  <!-- <div style="border-top: 1px solid #e0e0e0; margin: 12px 0;"></div> -->

  <mat-radio-group
    [ngModel]="selectedPeriodo"
    (ngModelChange)="onFiltroChange($event)"
    disabledInteractive
  >
    <div class="item-filter">
      <div class="lista">
        @for(periodo of periodoOptions; track periodo){
        <div class="item">
          <mat-radio-button
            class="filter-radio-margin"
            disableRipple
            color="primary"
            [value]="periodo.value"
            labelPosition="before"
            (click)="onRadioClick($event, periodo.value)"
          >
            <div style="position: absolute; width: 90%; height: 7%; cursor: pointer;"></div>
            <span class="filter-text" style="cursor: pointer">{{
              periodo.viewValue
            }}</span>
          </mat-radio-button>
        </div>
        }
      </div>
    </div>
  </mat-radio-group>
</div>
